import React from 'react';
import { Container } from './style';

export interface CheckboxProps {
  onChange: (checked?: boolean) => void;
  label: string;
}
export const Checkbox = ({ onChange, label }: CheckboxProps) => {
  const handleClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.currentTarget.blur();
    onChange();
  };
  return (
    <Container>
      <div className="checkbox-wrapper">
        <input
          type="checkbox"
          onChange={handleClick}
          data-testid="cmp-checkbox"
        />
        <span className="custom-checkbox" />
        <span className="hover-ring" />
      </div>
      <p>{label}</p>
    </Container>
  );
};
